const CONSENT_STORAGE_KEY = 'aprendos_cookie_consent_v1';
const CONSENT_VERSION = 1;

const defaultConsent = {
  version: CONSENT_VERSION,
  essential: true,
  analytics: false,
  decidedAt: null,
  updatedAt: null,
};

function parseConsent(rawValue) {
  if (!rawValue) return null;

  try {
    const parsed = JSON.parse(rawValue);
    if (parsed?.version !== CONSENT_VERSION) return null;

    return {
      ...defaultConsent,
      ...parsed,
      essential: true,
      analytics: Boolean(parsed.analytics),
    };
  } catch {
    return null;
  }
}

export function getStoredConsent() {
  if (typeof window === 'undefined') return defaultConsent;
  return parseConsent(window.localStorage.getItem(CONSENT_STORAGE_KEY)) || defaultConsent;
}

export function hasConsentDecision() {
  return Boolean(getStoredConsent().decidedAt);
}

export function hasAnalyticsConsent() {
  return getStoredConsent().analytics === true;
}

export function saveConsent(updates = {}) {
  const now = new Date().toISOString();
  const existing = getStoredConsent();
  const nextConsent = {
    ...existing,
    ...updates,
    version: CONSENT_VERSION,
    essential: true,
    analytics: Boolean(updates.analytics),
    decidedAt: existing.decidedAt || now,
    updatedAt: now,
  };

  if (typeof window !== 'undefined') {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(nextConsent));
    window.dispatchEvent(new CustomEvent('aprendos:consentchange', { detail: nextConsent }));
  }

  return nextConsent;
}

export { CONSENT_STORAGE_KEY };
